import React from 'react'
import { Formik } from 'formik'
import './index.css'
import { UploadFormProps } from '../../../../holidays/components/types'
import { Button, Modal } from '../../../../../components'
import { Icon } from '@iconify/react'
import { fileUploadSchema } from '../../../schema'
const UploadFormModal = ({ show, onClose, callBack }: UploadFormProps) => {
    const [forceValidation, setForceValidation] = React.useState(false)

    const handleDropZoneClick = () => {
        // Get the input element by ID
        const fileInput = document.getElementById('file')

        // Check if the input element exists
        if (fileInput) {
            // Trigger a click event on the input element
            fileInput.click()
        }
    }

    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        setFieldValue: (field: string, value: any) => void,
        setFieldTouched: (
            field: string,
            isTouched?: boolean,
            shouldValidate?: boolean
        ) => void
    ) => {
        const file = e.target.files?.[0]
        setFieldValue('file', file)
        setFieldValue('fileName', file?.name)
        setFieldTouched('file', true, true)
        setTimeout(() => setForceValidation(true), 0)
    }

    const RenderError = ({ values, errors, touched }: any) =>
        forceValidation ||
        (touched.file && values.file && values.fileName && errors.file) ? (
            <div className="error">{errors.file}</div>
        ) : null

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Upload"
            body={
                <Formik
                    initialValues={{ file: '', fileName: '' }}
                    onSubmit={(values) => {
                        callBack(values.file)
                    }}
                    validationSchema={fileUploadSchema}
                >
                    {({
                        values,
                        handleSubmit,
                        setFieldValue,
                        setFieldTouched,
                        touched,
                        isSubmitting,
                        errors,
                        handleBlur,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="upload-card">
                                <div className="main-container">
                                    <div
                                        id="dropZone"
                                        onClick={handleDropZoneClick}
                                    >
                                        <div className="error-center">
                                            <RenderError
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                            />
                                            {values.fileName && (
                                                <span className="">
                                                    {values.fileName}
                                                </span>
                                            )}
                                        </div>

                                        <div className="drop-zone-icons">
                                            <Icon icon="material-symbols:upload" />
                                        </div>
                                        <span className="drop-zone-text">
                                            <strong>Choose a file</strong> or
                                            drag it here.
                                        </span>

                                        <input
                                            type="file"
                                            id="file"
                                            name="file"
                                            style={{ display: 'none' }}
                                            onChange={(e) => {
                                                handleFileChange(
                                                    e,
                                                    setFieldValue,
                                                    setFieldTouched
                                                )
                                            }}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="footer-block">
                                <Button
                                    disabled={isSubmitting || !values.file}
                                    type="submit"
                                    onClick={() => console.log('')}
                                >
                                    UPLOAD
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="button"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    CANCEL
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default UploadFormModal
